import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

// Interceptor — adjunta el token JWT si existe (preparado para cuando se active login)
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

export default api
